<template>
  <div>
    <BLM-table
      v-loading="BLMloading"
      :data="tableData"
      :scroll="{ y: true }"
      :page-sizes="pageSizes"
      class="from_table"
      row-class-name="from_table_that"
      header-row-class-name="tableheader"
    >
      <!-- :maxHeight="500" 不要高度和滚动条 -->
      <!-- ------------左侧插槽----------------- -->
      <slot name="left"></slot>

      <el-table-column
        v-for="(item, index) in headData"
        :key="item.id?item.id:index"
        :prop="item.prop"
        :label="item.label ? item.label : '--'"
        :render-header="item['render-header']"
        :width="setLabelWidth(item.range, item.textAlignRight)"
        :min-width="setMaxHeigth(item.label, item.textAlignRight)"
        :align="item.textAlignRight ? 'right' : 'left'"
      >
        <template slot-scope="scope">
          <!-- 判断当前 prop 对应的值是否存在，不存在默认 - -  ， -->
          <BLM-badge
            v-if="item.dot && item.event"
            :color="item.event(scope.row[item.prop], scope.row).color"
            :text="item.event(scope.row[item.prop], scope.row).text"
            :class="[
              item.isClick ? 'td-canclick' : '',
              item.event(scope.row[item.prop], scope.row).textCor
                ? 'badge-color-red'
                : '',
            ]"
            @click.native="
              columnHandleClick(
                item.prop,
                scope.row[item.prop],
                scope.row,
                item.isClick
              )
            "
          />
          <div
            v-if="!item.dot"
            :style="{
              color:
                (item.event &&
                  item.event(scope.row[item.prop], scope.row) &&
                  item.event(scope.row[item.prop], scope.row).textCor) ||
                item.color
                  ? (item.event &&
                      item.event(scope.row[item.prop], scope.row) &&
                      item.event(scope.row[item.prop], scope.row).textCor) ||
                    item.color
                  : '',
            }"
          >
            <!-- !scope.row[item.prop] & (scope.row[item.prop] !== 0) & !item.event
                ? 'no_existent'
                : '', -->
            <!-- <div v-if="item.isfin" v-html="setHTML(scope.row[item.prop])"></div> -->
            <div
              v-if="item.isfin"
              :class="{ 'td-canclick': item.isClick }"
              @click="
                columnHandleClick(
                  item.prop,
                  scope.row[item.prop],
                  scope.row,
                  item.isClick
                )
              "
              v-html="setHTML(scope.row[item.prop])"
            ></div>

            <!-- <div v-if="!item.isfin" :title="SetContent(item.event, scope.row[item.prop])"> -->
            <div
              v-if="!item.isfin"
              :title="item.formatter ? item.formatter : SetContent(item.event, scope.row[item.prop])"
              :class="[
                item.isClick ? 'td-canclick' : '',
                item.event && item.event(scope.row[item.prop], scope.row)
                  ? item.event(scope.row[item.prop], scope.row).className
                  : '',
              ]"
              @click="
                columnHandleClick(
                  item.prop,
                  scope.row[item.prop],
                  scope.row,
                  item.isClick
                )
              "
            >
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="Top Left 提示文字"
                placement="top-start"
              > -->
              <!-- </el-tooltip> -->
              <div v-if="!item.tag && !item.isEllipsis">
                <!-- 如果需要自定义渲染dom的话，需要外侧传入custom插槽名 -->
                <div v-if="item.custom">
                  <slot
                    v-if="item.custom"
                    :name="item.custom"
                    :row="scope.row"
                  ></slot>
                </div>
                <div v-else>
                  {{
                    item.formatter ?
                      item.formatter(scope.row, item) :
                      SetContent(item.event, scope.row[item.prop])
                  }}
                </div>
              </div>
              <div v-if="item.isEllipsis">
                {{ EllipsisContent(scope.row[item.prop]) }}
              </div>
              <!--标签展示,超过三个展示...-->
              <div v-if="item.tag" style="overflow: auto">
                <div>
                  <el-tag v-if="tagIsShow(scope.row, item.prop, 0)">
                    {{ scope.row[item.prop][0] }}
                  </el-tag>
                  <div v-else>--</div>
                  <el-tag v-if="tagIsShow(scope.row, item.prop, 1)">
                    {{ scope.row[item.prop][1] }}
                  </el-tag>
                  <el-tag v-if="tagIsShow(scope.row, item.prop, 2)">
                    {{ scope.row[item.prop][2] }}
                  </el-tag>
                  <el-tag type="info" v-if="tagIsShow(scope.row, item.prop, 3)"
                    >还有其他{{
                      [...scope.row[item.prop]].length - 3
                    }}项</el-tag
                  >
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- ------------右插槽----------------- -->
      <slot name="right"> </slot>
    </BLM-table>
    <!--
      总条数
      当前页
      个数选择器支持个数选项
      点击事件
     -->
    <div class="spacing">
      <BLM-pagination
        :total="totalData"
        :page-num="pageNum"
        :pageSizes="pageSizes"
        :event="pageEvents"
        v-show="getHide()"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'FromMatching',
  props: {
    totalData: {
      type: Number,
      default: 0,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    headData: {
      type: Array,
      default: () => [],
    },
    pageEvent: {
      type: Function,
      default: () => {},
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50],
    },
    BLMloading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageNum: 1,
    }
  },
  methods: {
    // 某一列点击事件
    columnHandleClick(key, value, row, isClick) {
      if (!isClick) {
        return
      }

      this.$emit('handelClick', { key, value, row })
    },
    // 分页点击触发
    pageEvents({ pageSize, pageNum }) {
      // 每页数量
      // pageSize
      // 当前页
      this.pageNum = pageNum
      // 把当前页的数量以及当前页码，传给父组件
      this.pageEvent(pageSize, pageNum)
    },
    getHide() {
      return this.totalData > this.pageSizes[0]
    },
    setHTML(val) {
      if (val) {
        if (typeof val === 'string') {
          const arr = val.split(' ')
          return `<p>${arr[0]}</p><p>${arr[1]}</p>`
        } else {
          val = moment(val).format('YYYY-MM-DD HH:mm:ss')
          const arr = val.split(' ')
          return `<p>${arr[0]}</p><p>${arr[1]}</p>`
        }
      } else {
        return ''
      }
    },
    tagIsShow(row, target, index) {
      return row[target] && row[target][index]
    },
    EllipsisContent(text) {
      if (!text) {
        return '--'
      } else if (text.length >= 6) {
        return `${text.substr(0, 6)}...`
      } else {
        return text
      }
    },
  },
  computed: {
    SetContent() {
      return (event, content) => {
        if (event && event(content)) {
          if (typeof event(content) === 'object') {
            if (event(content).textVal) {
              return event(content).textVal
            } else {
              return '--'
            }
          } else if (event(content)) {
            return event(content)
          } else {
            return '--'
          }
        } else if (content || content === 0) {
          // console.log(content, '内容为0');
          return content
        } else {
          return '--'
        }
      }
    },
    setMaxHeigth() {
      return (label, textAlignRight) => {
        if (textAlignRight) {
          return 160
        } else if (label?.length > 4) {
          return 120
        } else {
          return ''
        }
      }
    },
    setLabelWidth() {
      return (range, textAlignRight) => {
        if (textAlignRight) {
          return 160
        } else if (range) {
          return range
        } else {
          return ''
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// 表格左右加padding
::v-deep tbody td:first-child .cell,
::v-deep thead th:first-child .cell {
  padding-left: 12px !important;
}

::v-deep tbody td:last-child .cell,
::v-deep thead th:last-child .cell {
  padding-right: 12px !important;
}

.from_table {
  overscroll-behavior: none;
  /****表格中可点击的元素蓝色小手******/
  ::v-deep .el-table__body .td-canclick {
    color: #0059dc;
    cursor: pointer;
    span {
      color: #0059dc;
      cursor: pointer;
    }
  }
  ::v-deep .el-table .cell {
    div,
    p {
      height: 100%;
    }
  }

  ::v-deep .tableheader {
    background: #F7F8FA;
    box-shadow: 0px 1px 0px 0px #EBEDF0;
  }

  ::v-deep .tableheader .is-right {
    .cell {
      padding: 0;
    }
    padding-left: 0;
    padding-right: 40px;
    // max-width: 180px;
  }
  ::v-deep .el-table__row .is-right {
    .cell {
      padding: 0;
    }
    padding-left: 0;
    padding-right: 40px;
    // min-width: ;
    // max-width: 180px;
  }
  // tbody内容超过三行省略号
  ::v-deep .el-table .cell {
    display: -webkit-box;
    overflow: hidden;

    white-space: normal !important;

    text-overflow: ellipsis;

    word-wrap: break-word;

    -webkit-line-clamp: 3;

    -webkit-box-orient: vertical;
  }

  .no_existent::before {
    content: '--';
  }

  body .el-table th.gutter {
    display: table-cell !important;
  }
  body .el-table colgroup.gutter {
    width: 140px;
    display: table-cell !important;
  }

}

// ::v-deep .from_table_that {
//   height: 76px;
// }
// 分页器间距
#blmPagination {
  padding: 16px 0;
}
::v-deep .textAlignRight {
  text-align: right;
}
/*
      按钮之间添加 | 分隔符
*/
::v-deep .wkl_contain {
  display: flex !important;
  align-items: center !important;
  button:not(:first-child)::before {
    content: '|' !important;
    width: 14px !important;
    height: 20px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #dcdee0;
    line-height: 20px;
    font-weight: 400;
    display: inline-block;
    text-align: center;
  }
  button + button {
    margin-left: 0 !important;
  }
}
::v-deep .el-tag {
  margin: 5px 0;
}

// ::v-deep .badge-color-red {
//   .ant-badge-status-text {
//     color: red !important;
//   }
// }
::v-deep .badge-color-red {
  .el-badge+span {
    color: red !important;
  }
}
</style>
